// removed by extract-text-webpack-plugin
module.exports = {"root":"Icon__root___mdjGr","spin":"Icon__spin___3_xL5","icon-spin":"Icon__icon-spin___rmWss","rotate90":"Icon__rotate90___1zpYF","rotate180":"Icon__rotate180___flgNj","rotate270":"Icon__rotate270___2oeKI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Icon/Icon.css
// module id = 99
// module chunks = 0